import Vue from 'vue'
import Component from 'vue-class-component'
import storageHelper from '@appbase/util/local-storage-helper'
import * as dateHelper from '@appbase/util/date-helper'
import * as typesAccount from '@account/store/types'
import api from '@gnb/api'
import { mapGetters } from 'vuex';

const NO_MORE_NOTICE_TODAY = 'NO_MORE_NOTICE_TODAY'

@Component({
computed: {
    ...mapGetters({
        user: typesAccount.USER,
    }),
},
})
export default class NoticeTicker extends Vue {
    user!: account.User;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    show: boolean = false
    index: number = 0
    item: string = ''
    items: string[] = [];
    isRunning: boolean = false
    timer: any = null

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    beforeMount() {

    }

    created() {
    const today = dateHelper.uGetDateFormat('yyyy-MM-dd', new Date())
    const value = storageHelper.get(NO_MORE_NOTICE_TODAY)
    if ((this.show = value !== today)) {
        api.common.getTodayNoticePopupList(this.user.comCode, false).then((res) => {
            // 텍스트 알림 팝업만
            res = res.filter(x => x.noticePopupType == 3);

            if(res.length > 0) {
                this.items = res.map(a => a.noticePopupContents);
                this.item = this.items[this.index]
                this.start();
            } else {
                this.show = false;
            }
        })     
    }
    }

    beforeDestroy() {
        this.stop()
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    handleClose() {
        this.show = false
        this.stop()
    }

    handleNoMoreToday() {
        this.handleClose()
        const today = dateHelper.uGetDateFormat('yyyy-MM-dd', new Date())
        storageHelper.set(NO_MORE_NOTICE_TODAY, today)
    }

    // ────────────────────────────────────────────────────────────────────────────────
    // Timer

    start() {
        this.isRunning = true
        if (!this.timer) {
            this.timer = setInterval(() => {
            ++this.index
            if (this.items.length === this.index) this.index = 0
            this.item = this.items[this.index]
            }, 2000)
        }
    }

    stop() {
        if (this.timer) {
            this.isRunning = false
            clearInterval(this.timer)
            this.timer = null
        }
    }
}
